// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doc-content {
    font-family: Arial, sans-serif;
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    color: #333;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.title {
    font-size: 24px;
    color: #000;
    font-weight: bold;
}

.c0, .c9 {  /* Titles and important text */
    font-weight: bold;
    color: #333;
}

.c1 {  /* Regular text */
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 10px;
}

.c3 {  /* Container for text */
    margin-bottom: 15px;
}

.c2 {  /* List items */
    margin-left: 20px;
    list-style-type: none; /* Removes default list style */
    position: relative; /* For custom list bullets */
}

.c2:before {  /* Custom bullet styling */
    content: '';
    width: 6px;
    height: 6px;
    background: #000;
    display: block;
    position: absolute;
    left: -15px;
    top: 10px;
    border-radius: 50%;
}

.c4, .lst-kix_rrwqm84z08d-0 {  /* Ordered list */
    counter-reset: section;
    padding-left: 0;
}

.c2 li-bullet-0:before {  /* Numbers for list items */
    counter-increment: section;
    content: counter(section) ".";
    left: -30px;
    top: 0;
    font-weight: bold;
}

.c8, .c9 {  /* Span elements with specific styles */
    font-weight: bold;
}

li.c2 {  /* List item spacing */
    padding: 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/Pages/TermsOfUse.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA,YAAY,8BAA8B;IACtC,iBAAiB;IACjB,WAAW;AACf;;AAEA,OAAO,iBAAiB;IACpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,OAAO,uBAAuB;IAC1B,mBAAmB;AACvB;;AAEA,OAAO,eAAe;IAClB,iBAAiB;IACjB,qBAAqB,EAAE,+BAA+B;IACtD,kBAAkB,EAAE,4BAA4B;AACpD;;AAEA,cAAc,0BAA0B;IACpC,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,kBAAkB;AACtB;;AAEA,+BAA+B,iBAAiB;IAC5C,sBAAsB;IACtB,eAAe;AACnB;;AAEA,0BAA0B,2BAA2B;IACjD,0BAA0B;IAC1B,6BAA6B;IAC7B,WAAW;IACX,MAAM;IACN,iBAAiB;AACrB;;AAEA,YAAY,uCAAuC;IAC/C,iBAAiB;AACrB;;AAEA,SAAS,sBAAsB;IAC3B,cAAc;AAClB","sourcesContent":[".doc-content {\n    font-family: Arial, sans-serif;\n    max-width: 800px;\n    margin: 20px auto;\n    padding: 20px;\n    background: #fff;\n    color: #333;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.1);\n}\n\n.title {\n    font-size: 24px;\n    color: #000;\n    font-weight: bold;\n}\n\n.c0, .c9 {  /* Titles and important text */\n    font-weight: bold;\n    color: #333;\n}\n\n.c1 {  /* Regular text */\n    font-size: 16px;\n    line-height: 1.6;\n    margin-bottom: 10px;\n}\n\n.c3 {  /* Container for text */\n    margin-bottom: 15px;\n}\n\n.c2 {  /* List items */\n    margin-left: 20px;\n    list-style-type: none; /* Removes default list style */\n    position: relative; /* For custom list bullets */\n}\n\n.c2:before {  /* Custom bullet styling */\n    content: '';\n    width: 6px;\n    height: 6px;\n    background: #000;\n    display: block;\n    position: absolute;\n    left: -15px;\n    top: 10px;\n    border-radius: 50%;\n}\n\n.c4, .lst-kix_rrwqm84z08d-0 {  /* Ordered list */\n    counter-reset: section;\n    padding-left: 0;\n}\n\n.c2 li-bullet-0:before {  /* Numbers for list items */\n    counter-increment: section;\n    content: counter(section) \".\";\n    left: -30px;\n    top: 0;\n    font-weight: bold;\n}\n\n.c8, .c9 {  /* Span elements with specific styles */\n    font-weight: bold;\n}\n\nli.c2 {  /* List item spacing */\n    padding: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
